import * as Sentry from '@sentry/react';
import { SentryTeams } from '@mews/enums';
import { SentryProjectConfig, SentryTags } from './types';

export const getSentryTeamConfig = (sentryConfigurations: SentryProjectConfig[], team: SentryTeams) =>
    sentryConfigurations.find((sentryConfiguration) => sentryConfiguration.team === team);

export const setSentryTransport = (sentryConfigurations: SentryProjectConfig[]) =>
    Sentry.makeMultiplexedTransport(Sentry.makeFetchTransport, ({ getEvent }) => {
        const event = getEvent();
        const config = getSentryTeamConfig(sentryConfigurations, event?.tags?.[SentryTags.Team] as SentryTeams);

        /* Empty array means that default dsn from .init() is used instead */
        return config ? [{ dsn: config.dsn, release: config.release }] : [];
    });
